var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "members-dep",
    {
      attrs: {
        "popover-display": "block",
        "dep-checked-data": _vm.dataStrucs,
        "user-checked-data": _vm.dataUsers,
      },
      on: { popoverSubmit: _vm.popoverSubmit, show: _vm.popoverShow },
    },
    [
      !_vm.$slots.reference
        ? _c(
            "div",
            { attrs: { slot: "membersDep" }, slot: "membersDep" },
            [
              _c(
                "flexbox",
                {
                  staticClass: "structure-container xh-form-border",
                  class: ["is_valid", { is_focus: _vm.showPopover }],
                  attrs: { wrap: "wrap" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.focusClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._l(_vm.showDataValue, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "user-item",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.deleteItem(item, index)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(item.name || item.realname) + "\n        "
                        ),
                        _c("i", { staticClass: "delete-icon el-icon-close" }),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.allData.length > _vm.max
                    ? _c("i", { staticClass: "el-icon-more" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    class: [
                      "el-icon-arrow-up",
                      { "is-reverse": _vm.showPopover },
                    ],
                  }),
                  _vm._v(" "),
                  _vm.allData.length == 0
                    ? _c("div", { staticClass: "add-item text-one-line" }, [
                        _vm._v(_vm._s(_vm.placeholder)),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._t("reference", null, { slot: "reference" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }